import React from "react";
import "./media.css";
import Gold from "../../assets/logo.png";

const Media = () => {
  return (
    <div className="media__landing">
      <h2 className="mediapage-logo-header">LOGOS</h2>
      <div className="media_container">
        <img src={Gold} className="image_item" alt="Media" />
      </div>
    </div>
  );
};

export default Media;
